const submissions = () => import('../views/editorial-office/manuscripts')
const corespondenceRecord = () =>
  import('../views/editorial-office/manuscripts/corespondence-record')
const details = () => import('../views/editorial-office/manuscripts/details')
const reviewReport = () =>
  import('../views/editorial-office/manuscripts/details/review-report')
const submitManuscript = () => import('../views/author/submit-manuscripts')
const manuscriptInformation = () =>
  import('../views/author/submit-manuscripts/manuscript-information')
const authorInformation = () =>
  import('../views/author/submit-manuscripts/author-information')
const suggestOpposeReviewers = () =>
  import('../views/author/submit-manuscripts/suggest-oppose-reviewers')
const uploadDocuments = () =>
  import('../views/author/submit-manuscripts/upload-documents')
const confirmationSubmission = () =>
  import('../views/author/submit-manuscripts/confirmation-submission')
const otherAuthor = () =>
  import('../views/editorial-office/manuscripts/other-author')
const reviewHistory = () =>
  import('../views/editorial-office/manuscripts/details/review-history')
const refuseDetail = () => import('../views/editorial-office/refuse-detail')

const manageVolunteers = () =>
  import('../views/editorial-office/manage-volunteers')

// 编辑决策
const decisionsEditorial = () =>
  import('../views/editorial-office/manuscripts/details/decisions-editorial')

// Author Revision
const authorRevision = () =>
  import('../views/editorial-office/manuscripts/details/author-revision')

// 编辑决策外编
const decisionAcedemic = () =>
  import('../views/editorial-office/manuscripts/details/decision-academic')

const discountVoucher = () =>
  import('../views/editorial-office/discount-voucher')

const path = '/editorial-office'

export default [
  {
    path: path + '/manuscripts',
    component: submissions,
    name: '/editorial-office/manuscripts',
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/editor-task/submissions',
    component: submissions,
    name: '/editorial-office/manuscripts',
    redirect: path + '/manuscripts'
  },
  {
    path: path + '/manuscripts/corespondence-record/:id',
    component: corespondenceRecord,
    name: '/editorial-office/manuscripts/corespondence-record'
  },
  {
    path: path + '/manuscripts/details/:id',
    component: details,
    name: '/editorial-office/manuscripts/details'
  },
  {
    path: '/editor-task/submissions/details/:id',
    redirect: path + '/manuscripts/details/:id',
    component: details,
    name: '/editorial-office/manuscripts/details'
  },
  {
    path: path + '/manuscripts/details/review-history/:id',
    component: reviewHistory,
    name: '/editorial-office/manuscripts/details/review-history'
  },

  {
    path: path + '/manuscripts/submit-manuscripts',
    component: submitManuscript,
    name: '/editorial-office/submit-manuscripts',
    children: [
      {
        path: path + '/manuscripts/submit-manuscripts/step1',
        component: manuscriptInformation,
        name: '/editorial-office/submit-manuscripts/step1'
      },
      {
        path: path + '/manuscripts/submit-manuscripts/step2',
        component: authorInformation,
        name: '/editorial-office/submit-manuscripts/step2'
      },
      {
        path: path + '/manuscripts/submit-manuscripts/step3',
        component: uploadDocuments,
        name: '/editorial-office/submit-manuscripts/step3'
      },
      {
        path: path + '/manuscripts/submit-manuscripts/step4',
        component: suggestOpposeReviewers,
        name: '/editorial-office/submit-manuscripts/step4'
      },
      {
        path: path + '/manuscripts/submit-manuscripts/step5',
        component: confirmationSubmission,
        name: '/editorial-office/submit-manuscripts/step5'
      }
    ]
  },

  {
    path: path + '/manuscripts/details/reviews-report/:id',
    component: reviewReport,
    name: '/manuscripts/details/reviews-report/:id'
  },
  {
    path: '/editor-task/submissions/reviews-detail/:id',
    component: reviewReport,
    name: '/manuscripts/details/reviews-report',
    redirect: path + '/manuscripts/details/reviews-report/:id'
  },
  {
    path: path + '/manuscripts/details/other-author/:id',
    component: otherAuthor,
    name: '/editorial-office/manuscripts/details/other-author'
  },
  {
    path: path + '/manuscripts/details/refuse/:id',
    component: refuseDetail,
    name: '/editorial-office/manuscripts/details/refuse'
  },
  {
    path: path + '/manage-volunteers',
    component: manageVolunteers,
    name: '/editorial-office/manage-volunteers'
  },
  {
    path: '/editor-task/manage-volunteers',
    redirect: path + '/manage-volunteers',
    component: manageVolunteers,
    name: '/editorial-office/manage-volunteers'
  },
  {
    path: '/editorial-office/discount-voucher',
    component: discountVoucher,
    name: '/editorial-office/discount-voucher'
  },

  // 编辑决策
  {
    path: path + '/manuscripts/decisions-editorial',
    component: decisionsEditorial,
    name: '/editorial-office/manuscripts/decisions-editorial'
  },
  {
    path: path + '/manuscripts/decisions-final',
    component: decisionsEditorial,
    name: '/editorial-office/manuscripts/decisions-final'
  },
  {
    path: path + '/manuscripts/author-revision',
    component: authorRevision,
    name: '/editorial-office/manuscripts/author-revision'
  },

  // 重定向
  {
    path: '/submissions-menu/submitted-editorial/finaldecisions',
    redirect: path + '/manuscripts/decisions-final',
    component: decisionsEditorial,
    name: '/editorial-office/manuscripts/decisions-final'
  },
  // 编辑决策外编
  {
    path: path + '/manuscripts/decision-external/:type/:id',
    component: decisionAcedemic,
    name: '/editorial-office/manuscripts/decision-external'
  }
  // {
  //   path: path + '/manuscripts/decision-external/report/:type/:id',
  //   component: decisionAcedemic,
  //   name: '/editorial-office/manuscripts/decision-external/report'
  // }
]
